<template>
  <common-addon :show-download="false">
    <template #viewAccountOnly>
      <div class="opc-zoom-custom-ai-companion-success__actions">
        <zm-button
          data-testid="checkout-button-477"
          :data-url="getStartedTargetUrl"
          size="lg"
          type="primary"
          @click="goToAiCompanionPage"
        >
          {{ $t('billing.success.get_started') }}
        </zm-button>
        <view-account type="primary" />
      </div>
    </template>
  </common-addon>
</template>

<script>
import Base from '@/views/succezz/components/common-addon.vue';
import ViewAccount from '@/views/succezz/thanks-template/view-account.vue';
import { navigateToTargetPage } from '@/utils/modal-utils.js';
import { getEmailCTAsTrackingUrl, UTM_CONTENT_CODE } from '@/views/succezz/utils/email-ctas-tracking';
export default {
  extends: Base,
  components: {
    CommonAddon: Base,
    ViewAccount,
  },
  computed: {
    getStartedTargetUrl() {
      return getEmailCTAsTrackingUrl('https://ai.zoom.us/', { utmContent: UTM_CONTENT_CODE.getStarted });
    },
  },
  methods: {
    goToAiCompanionPage() {
      this.$tracking.buyInteraction('purchase confirmation', 'get started');
      navigateToTargetPage('https://ai.zoom.us/');
    },
  },
};
</script>

<style lang="scss">
.opc-zoom-custom-ai-companion-success__actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}
</style>
